import { createSlice } from '@reduxjs/toolkit';

export const SizeItemsSlice = createSlice({
  name: 'sizeItems',
  initialState: {
    sizeItems: [],
    sizeItemsDotacion: [],
  },
  reducers: {
    setSizeItemsRedux: (state, { payload }) => {
      state.sizeItems = payload;
    },
    setBeneficiariosRedux: (state, { payload }) => {
      state.sizeItemsDotacion = payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setSizeItemsRedux, setBeneficiariosRedux } = SizeItemsSlice.actions;
